import React from 'react';
import '../scss/home-page-skeleton.scss';

function HomePageSkeleton() {
  return (
    <div className='main home-page home-page-skeleton'>
      {/* Header Skeleton */}
      <div className='skeleton-header'>
        <div className='skeleton-logo'></div>
        <div className='skeleton-nav'>
          <div className='skeleton-nav-item'></div>
          <div className='skeleton-nav-item'></div>
          <div className='skeleton-nav-item'></div>
        </div>
      </div>

      {/* Banner Skeleton */}
      <div className='skeleton-banner'></div>

      {/* Browse Section Skeleton */}
      <div className='skeleton-section common-padding'>
        <div className='skeleton-title'></div>
        <div className='skeleton-items'>
          <div className='skeleton-card'></div>
          <div className='skeleton-card'></div>
          <div className='skeleton-card'></div>
          <div className='skeleton-card'></div>
        </div>
      </div>

      {/* Recommended Section Skeleton */}
      <div className='skeleton-section common-padding'>
        <div className='skeleton-title'></div>
        <div className='skeleton-items'>
          <div className='skeleton-property-card'></div>
          <div className='skeleton-property-card'></div>
          <div className='skeleton-property-card'></div>
        </div>
      </div>

      {/* CTA Section Skeleton */}
      <div className='skeleton-section common-padding skeleton-cta'></div>

      {/* Property Type Selector Skeleton */}
      <div className='skeleton-section common-padding'>
        <div className='skeleton-title'></div>
        <div className='skeleton-items'>
          <div className='skeleton-toggle-item'></div>
          <div className='skeleton-toggle-item'></div>
          <div className='skeleton-toggle-item'></div>
        </div>
      </div>

      {/* Footer Skeleton */}
      <div className='skeleton-footer'>
        <div className='skeleton-footer-item'></div>
        <div className='skeleton-footer-item'></div>
        <div className='skeleton-footer-item'></div>
      </div>
    </div>
  );
}

export default HomePageSkeleton;
